/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { NextStatesResponse } from '../../models/next-states-response';

export interface TicketControllerFindTicketNodes$Params {
  id: number;
}

export function ticketControllerFindTicketNodes(http: HttpClient, rootUrl: string, params: TicketControllerFindTicketNodes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: NextStatesResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerFindTicketNodes.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: NextStatesResponse;
      }>;
    })
  );
}

ticketControllerFindTicketNodes.PATH = '/ticket/nodes/{id}';
